.contentWithPaddingForFooter {
    padding-bottom: 150px;
}

.menuAndPointsContainer {
    display: flex;
    align-items: center;
    gap: 20px;
}

.headerPoints {
    /* 141px is the width of the divs containing the points input box and the overlfow menu. This property left-aligns the "header" text with the points input. */
    width: 141px;
}

.pointsContainer {
    width: 100px;
    display: flex;
    align-items: center;
}

.accordionHeaderContainer,
.accordionRow {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
}

.accordionHeaderContainer {
    display: flex;
    align-items: center;
    width: 100%;
    margin: 20px 0px 0px 0px;
    border-radius: 9px;
    background-color: rgba(5, 60, 89, 0.06);
    padding: 5px 0px 5px 12px;
    border-radius: 9px;
    background-color: rgba(5, 60, 89, 0.06);
}

.headerSectionsQuestionsAndAnswers {
    display: flex;
    padding: 0px 0px 0px 10px;
}

.questionTextAndTypeContainer {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-top: 4px;
    margin-bottom: 4px;
}